import { NgxLoggerLevel } from 'ngx-logger';
import 'zone.js/dist/zone-error';

export const apiKey = 'LOHI_API_URL';
export const logLevelKey = 'LOHI_LOG_LEVEL';
export const pollingEnabledKey = 'LOHI_POLLING_ENABLED';
const defaultApiUrl = 'https://stage.api.lohi.ai';

export const environment = {
  production: false,
  get api(): string {
    return getSessionThenLocalWithDefault(apiKey, defaultApiUrl);
  },

  get logLevel(): NgxLoggerLevel {
    const logLevelString = getSessionThenLocalWithDefault(logLevelKey, 'ERROR');
    for (const key of Object.keys(NgxLoggerLevel)) {
      if (key === logLevelString) {
        return NgxLoggerLevel[key];
      }
    }
    return NgxLoggerLevel.ERROR;
  },

  get pollingEnabled(): boolean {
    const refreshInBackground = getSessionThenLocalWithDefault(pollingEnabledKey, 'true');
    return refreshInBackground.toLowerCase() === 'true';
  },
  intercomId: 'fq7khmfq',
  firebaseApiKey: 'AIzaSyC-c8kIxYnYOWHEnTBQiblF1bzFvyBAQZw',
};

function getSessionThenLocalWithDefault(key: string, defaultValue: string): string {
  const sessionValue = sessionStorage.getItem(key);
  if (sessionValue) {
    return sessionValue;
  }

  const localValue = localStorage.getItem(key);
  if (localValue) {
    return localValue;
  }

  return defaultValue;
}
